/* eslint-disable no-use-before-define,no-restricted-globals,jsx-a11y/anchor-is-valid */
import React from 'react'
import { show, disclosures, hideModal, getConfig } from '../twd'

export const showBondOrder = (arg) => {
    const f = getConfig('entitlements.ETradeOrderTicket', 'No') === 'Yes'
    const nav = f ? 'order-ticket' : 'tools.bond-order'
    show(nav, arg)
}


export const buy = ({cusip, acctNo='', qty='', from, action='B', sourceAction='', style={}, extraClassName=''} = {}) => {
    return <a href='#'
        data-name="buy-button"
        data-from={from}
        type="button"
        className={"btn btn-sm btn-primary-outline " + extraClassName}

        style={{display:'inline-block', maxWidth:'100%', ...style}}

        onClick={() => {
            hideModal()
            showBondOrder({
                action,
                cusip,
                acctNo,
                qty,
                sourceAction,
                from,
                ts: Date.now(),
            })
        }}
    >Buy</a>
}

export const sell = ({cusip, acctNo='', qty='', from, action='S', sourceAction='', style={}, extraClassName=''} = {}) => {
    let cs = getConfig('cusips_held', {})
    let h = cs[cusip]
    if (!h) return null

    let n = h.length>0
    acctNo = acctNo || (n ? h[0].acctNo : '')
    sourceAction = sourceAction || (n ? 'H' : '')

    return <a href='#'
        data-name="sell-button"
        data-from={from}
        type="button"
        className={"btn btn-sm btn-primary-outline " + extraClassName}

        style={{display:'inline-block', maxWidth:'100%', ...style}}

        onClick={() => {
            hideModal()
            showBondOrder({
                action,
                cusip,
                acctNo,
                qty,
                sourceAction,
                from,
                ts: Date.now(),
            })
        }}
    >Sell</a>
}

export const orderDetail = ({orderNo} = {}) => {
    return <a href='#'
        data-name="order-detail-link"
        className="link-button"
        style={{cursor:'pointer'}}
        onClick={() => {
            show('tools.order-detail', {orderNo})
        }}
    >{orderNo}</a>

}


export const orderPhone = ({style={}} = {}) => {
    return <a href='#'
        data-name="order-call-link"
        style={{cursor:'pointer', ...style}}
        onClick={orderPhoneModal}
        alt="Order by telephone"
    >
        <i className="material-icons et-icon-xs" aria-hidden="true">phone</i>
    </a>
}

const orderPhoneModal = () => {
    disclosures({
        title:'This asset class is not available for online trading',
        html:`
        <p class="text-center text-bold">
        Please call our Fixed Income Specialists at<br/>
        877-355-3237 with inquiries or for support placing orders.
        </p>
        `,
        buttonClass: 'text-center',
        buttonStyle: {display:'block'},
        buttons:[{
            label: 'Call 877-355-3237',
            onClick: () => {
                hideModal()
                location.href='tel:18773553237'
            }
        }],
        modalClass:"modal-dialog modal-sm"
    })
}